const reviewTrack=document.getElementById('review-track');
const reviewCards=[...reviewTrack.querySelectorAll('.review-card')];
let reviewIndex=0;
const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function showReview(index){reviewIndex=(index+reviewCards.length)%reviewCards.length;reviewTrack.scrollTo({left:reviewCards[reviewIndex].offsetLeft-reviewCards[0].offsetLeft,behavior:reducedMotion?'instant':'smooth'})}
document.getElementById('review-prev').addEventListener('click',()=>showReview(reviewIndex-1));
document.getElementById('review-next').addEventListener('click',()=>showReview(reviewIndex+1));
let reviewTimer;
function stopReviewTimer(){clearInterval(reviewTimer)}
function startReviewTimer(){if(reducedMotion)return;stopReviewTimer();reviewTimer=setInterval(()=>{if(document.visibilityState==='visible'&&!document.getElementById('landing').classList.contains('hidden'))showReview(reviewIndex+1)},5500)}
reviewTrack.addEventListener('pointerenter',stopReviewTimer);
reviewTrack.addEventListener('pointerleave',startReviewTimer);
reviewTrack.addEventListener('focusin',stopReviewTimer);
reviewTrack.addEventListener('focusout',startReviewTimer);
reviewTrack.addEventListener('scroll',()=>{const left=reviewTrack.scrollLeft;let nearest=0,dist=Infinity;reviewCards.forEach((card,i)=>{const d=Math.abs(card.offsetLeft-reviewCards[0].offsetLeft-left);if(d<dist){dist=d;nearest=i}});reviewIndex=nearest},{passive:true});
startReviewTimer();

const stickyCta=document.getElementById('sticky-cta');
const landing=document.getElementById('landing');
const hero=landing.querySelector('.hero');
const heroCta=hero.querySelector('[data-ad-quiz]');
const footer=landing.querySelector('.footer');
const mobileViewport=window.matchMedia('(max-width: 600px)');
let stickyUpdatePending=false;
function syncStickyCta(){
  stickyUpdatePending=false;
  const heroPassed=hero.getBoundingClientRect().bottom<=0;
  const mobile=mobileViewport.matches;
  const heroCtaRect=heroCta.getBoundingClientRect();
  const footerVisible=footer.getBoundingClientRect().top<window.innerHeight;
  // Show after the hero button scrolls above the viewport, then keep it
  // steady through the editorial sections instead of toggling at every CTA.
  const show=!landing.classList.contains('hidden')&&(mobile?heroCtaRect.bottom<=0:heroPassed&&!footerVisible);
  stickyCta.classList.toggle('is-visible',show);
  stickyCta.inert=!show;
  stickyCta.setAttribute('aria-hidden',String(!show));
}
function scheduleStickyCtaUpdate(){
  if(stickyUpdatePending)return;
  stickyUpdatePending=true;
  requestAnimationFrame(syncStickyCta);
}
window.addEventListener('scroll',scheduleStickyCtaUpdate,{passive:true});
window.addEventListener('resize',scheduleStickyCtaUpdate);
new MutationObserver(scheduleStickyCtaUpdate).observe(landing,{attributes:true,attributeFilter:['class']});
syncStickyCta();
